export default function downloadCsv(csv, filename) {
  const blob = new Blob([csv], {type: "text/csv;charset=utf-8;"})
  const link = document.createElement("a")
  const url = URL.createObjectURL(blob)
  link.setAttribute("href", url)
  link.setAttribute("download", filename)
  link.style.visibility = "hidden"
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const dataToCsv = (data: {[key: string]: any}[]): string => {
  const keys: string[] = []

  // Get keys across ALL the objects in the collection passed
  data.map((row) => {
    Object.keys(row).map((header) => {
      if (!keys.includes(header)) {
        keys.push(header)
      }
    })
  })

  // Create csv lines from headers. Filling with "" if object doesn't have a property
  const csvRows = data.map((object) => keys.map((key) => object[key] || "").join(","))

  const csvHeaders = keys.join(",")
  const csvBody = csvRows.join("\n")

  // Start csv with \ufeff as the csv may contain utf-8 characters
  return `\ufeff${csvHeaders}\n${csvBody}`
}
